import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  formData: {},
  fetch_allLeads_Loading: false,
    // leadId: "",
    // age: '',
    // smokingValue: "",
    // genderValue: "",
    // retireAge: '',
    // goalCategory: "",
    //   annualIncome: "",
    //   loanTaken: false,
    //   remainingLoanPeriod: "",
    //   totalSaving: "",
    //   monthlyExpense: "",
    //   loanAmount: "",
    //   assuredType: "",

};

// const fetchPageFormData1 = (state, action) => {
//   //console.log("action Reducers===>>", action);
//   const payload = { ...action.formData1 };
//   return updateObject(state, {
//     formData: payload,
//   });
// };
// const fetchPageFormData2 = (state, action) => {
//   const payload = { ...action.formData2 };
//   return updateObject(state, {
//     formData: payload,
//   });
// };
// const fetchAllGapData = (state, action) => {
//   const payload = { ...state.formData, ...action.formData };
//   return updateObject(state, {
//     formData: payload,
//   });
// };
// const fetchGapCalculator = (state, action) => {
//   const payload = { ...state.formData, ...action.formData };
//   return updateObject(state, {
//     formData: payload,
//   });
// };
const storeAllGapCalcFromData = (state, action)=>{
  //console.log("store---formdatacal", state, action);
  const payload = {...state.formData, ...action.formData }
  return updateObject(state,{
    formData:payload,
  })
}

const fetchGapCalcStart = (state, action) => {
  // const payload = { ...state.formData, ...action.formData };
  return updateObject(state, {
    fetch_allLeads_Loading: true,
  });
};

const fetchGapCalcSuccess = (state, action) => {
  //console.log("State->1st page payload", state, "action->", action);
  const payload = {...state.formData, ...action.formData}
  return updateObject(state, {
    formData: payload,
  });
};


const fetchGapCalcFail = (state, action) => {
  // const payload = { ...state.formData, ...action.formData };
  return updateObject(state, {
    fetch_allLeads_Loading: false,
  });
};




// get form data
const getGapDataStart =(state)=>{
  return updateObject(state,{
    fetch_allLeads_Loading: true,
  })
}

const getGapDataSuccess=(state,action)=>{
  //console.log("State->getGapDataSuccess", state, "action->getGapDataSuccess", action);
  const payload = action.LeadID
  return updateObject(state, {
    formData: payload,
  });
}

const getGapDataFail = (state, action) => {
  // const payload = { ...state.formData, ...action.formData };
  return updateObject(state, {
    fetch_allLeads_Loading: false,
  });
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Calculator
    case actionTypes.FETCH_GAP_CALC_START:
      return fetchGapCalcStart(state, action);
    case actionTypes.FETCH_GAP_CALC_SUCCESS:
      return fetchGapCalcSuccess(state, action);
    case actionTypes.FETCH_GAP_CALC_FAIL:
      return fetchGapCalcFail(state, action);

    case actionTypes.STORE_ALL_CALC_FORM_DATA:
      return storeAllGapCalcFromData(state,action);

    case actionTypes.GET_GAP_DATA_START:
      return getGapDataStart(state,action);
    case actionTypes.GET_GAP_DATA_SUCCESS:
      return getGapDataSuccess(state,action);
    case actionTypes.GET_GAP_DATA_FAIL:

      return getGapDataFail(state,action);
    case actionTypes.RESET_GAP_DATA:
      return {...initialState}
    // case actionTypes.FETCH_ALL_GAP_DATA:
    //   return fetchAllGapData(state, action);
    // case actionTypes.FETCH_FORMDATA_PAGE1:
    //   return fetchPageFormData1(state, action);
    // case actionTypes.FETCH_FORMDATA_PAGE2:
    //   return fetchPageFormData2(state, action);
    default:
      return state;
  }
};

export default reducer;